import {
  GET_CALL_LIST_REQUEST,
  GET_CALL_LIST_SUCCESS,
  GET_CALL_LIST_FAILURE,
  GET_REACTION_LIST_REQUEST,
  GET_REACTION_LIST_SUCCESS,
  GET_REACTION_LIST_FAILURE,
  LOG_OUT_SUCCESS,
} from '../../constants/ActionTypes'
import * as errMessages from '../../constants/ErrorMessages';
import { formatErrorMessage } from '../../utils/utils'

const { OrderedMap } = require('immutable')

const initialState = {
  // コール
  isLoadingCalls: false,
  callList: OrderedMap({}),
  pageInfoCalls: {},
  // リアクション
  isLoadingReactions: false,
  reactionList: OrderedMap({}),
  pageInfoReactions: {},
}

export default (state = initialState, action) => {
  state = {
    ...state,
    shortMessage: '',
    successMessage: '',
    errorMessage: '',
  }

  let list;

  switch (action.type) {
    case GET_CALL_LIST_REQUEST:
      return {
        ...state,
        isLoadingCalls: true,
        callList: action.payload.overwrite ? OrderedMap({}) : state.callList,
        pageInfoCalls: action.payload.overwrite ? {} : state.pageInfoCalls,
      }
    case GET_CALL_LIST_SUCCESS:
      list = action.payload.overwrite ? OrderedMap({}) : state.callList;
      action.payload.statuses.forEach(item => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        callList: list,
        isLoadingCalls: false,
        pageInfoCalls: action.payload.pageInfo,
      }
    case GET_CALL_LIST_FAILURE:
      return {
        ...state,
        isLoadingCalls: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case GET_REACTION_LIST_REQUEST:
      return {
        ...state,
        isLoadingReactions: true,
        reactionList: action.payload.overwrite ? OrderedMap({}) : state.reactionList,
        pageInfoReactions: action.payload.overwrite ? {} : state.pageInfoReactions,
      }
    case GET_REACTION_LIST_SUCCESS:
      list = action.payload.overwrite ? OrderedMap({}) : state.reactionList;
      action.payload.statuses.forEach(item => {
        list = list.set(item.id, item);
      });
      return {
        ...state,
        reactionList: list,
        isLoadingReactions: false,
        pageInfoReactions: action.payload.pageInfo,
      }
    case GET_REACTION_LIST_FAILURE:
      return {
        ...state,
        isLoadingReactions: false,
        errorMessage: formatErrorMessage(action.payload.error, errMessages.ERR_GET_FAILURE),
      }
    case LOG_OUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/orderDashboard.js